import { useQuery } from "@tanstack/react-query";
import { CloudForwarderForwarders } from "@graylog/enterprise-api";
import i18n from "i18n";
import { defaultOnError } from "util/conditional/onError";
const BASIC_FORWARDER_USER_QUERY_KEY = "basic_forwarder_user";
const getForwarderUser = async () => CloudForwarderForwarders.getBasicForwarderUser().then((userResponse) => ({
  serviceAccount: userResponse.service_account,
  fullName: userResponse.full_name,
  readOnly: userResponse.read_only,
  id: userResponse.id,
  username: userResponse.username
}));
const useBasicForwarderUser = () => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: [BASIC_FORWARDER_USER_QUERY_KEY],
    queryFn: () => defaultOnError(
      getForwarderUser(),
      i18n.t("notifications.load_forwarder_user_failed", { ns: "enterprise_forwarder" }),
      i18n.t("notifications.load_forwarder_user_failed_title", { ns: "enterprise_forwarder" })
    )
  });
  return {
    data,
    isLoading,
    refetch
  };
};
export default useBasicForwarderUser;
